import { Component, OnInit, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "../../../base/base-step.component";

@Component({
    selector: 'evento-prestacao-conta-etapa4',
    templateUrl: './evento-prestacao-conta-etapa4.component.html',
})
export class CrudEventoPrestacaoContaEtapa4Component extends BaseStepComponent {

    listaDiasSemana: any[] = [];
    listaPais: any[] = [];
    listaCidades: any[] = [];
    listaUf: any[] = [];

    init() {
        this.service.ListarTodos('uf').subscribe(data => {
            this.listaUf = data;
        });
        this.service.ListarTodos('combo/dia_semana').subscribe(data => {
            this.listaDiasSemana = data;
        });
        this.service.ListarTodos('pais').subscribe(data => {
            this.listaPais = data;
        });
        this.service.ListarTodos('cidade').subscribe(data => {
            this.listaCidades = data;
        });   
    
    }
    
}


// WEBPACK FOOTER //
// ./src/app/evento-prestacao-conta/crud/etapas/evento-prestacao-conta-etapa4.component.ts